import { useDispatch, useSelector } from "react-redux";
import { useGetBranchesQuery } from "../admin/adminApi";
import { useClaims } from "../auth/useClaims";
import { branchSelected, selectSelectedBranchId } from "./branchFilterSlice";

// Drives the header BranchPicker and every branch-scoped list screen
// (Customers, Products, Employees, Users - handoff §13.1). Options are the
// branches on the logged-in user's own token, resolved to {branchId} via the
// admin/branches catalog; an all-branch user also gets an explicit "All
// branches" choice, a branch-scoped user just sees their own branch(es) and
// the picker is effectively a label (server already no-ops a redundant
// branchId= for them).
export const useBranchFilter = () => {
  const dispatch = useDispatch();
  const selectedBranchId = useSelector(selectSelectedBranchId);
  const { branches: callerBranchCodes, isAllBranches } = useClaims();
  const { data: allBranches = [] } = useGetBranchesQuery();

  const availableBranches = isAllBranches
    ? allBranches
    : allBranches.filter((b) => callerBranchCodes?.includes(b.branchCode));

  const setSelectedBranchId = (branchId) => dispatch(branchSelected(branchId));

  return {
    selectedBranchId,
    setSelectedBranchId,
    availableBranches,
    showAllOption: isAllBranches,
  };
};
